import 'fullpage.js/vendors/scrolloverflow';
import fullpage from 'fullpage.js';

(function () {
  var page = document.querySelector('.js-fullpage');
  var config = window.meinplanFullpageConfig || {};
  var sections = page
    ? Array.prototype.slice.call(page.querySelectorAll('.front-page__panel'))
    : [];
  var anchors = sections.map(function (section) {
    return section.getAttribute('data-anchor');
  });
  var navigationTooltips = sections.map(function (section) {
    return section.getAttribute('data-tooltip');
  });
  var nextButtons = page
    ? Array.prototype.slice.call(page.querySelectorAll('.js-fullpage-next'))
    : [];
  var introSection = page && page.querySelector('.front-page__section--intro');
  var dateSection = page && page.querySelector('.front-page__section--date');
  var greetingsSection = page && page.querySelector('.front-page__section--greetings');
  var benefitsSection = page && page.querySelector('.front-page__section--benefits');
  var packagesSection = page && page.querySelector('.front-page__section--packages');
  var hallPlanSection = page && page.querySelector('.front-page__section--hall-plan');
  var bookingSection = page && page.querySelector('.front-page__section--booking');
  var participantsSection =
    page && page.querySelector('.front-page__section--participants');
  var footerSection = page && page.querySelector('.front-page__panel--footer');
  var animatedSections = [
    introSection,
    dateSection,
    greetingsSection,
    benefitsSection,
    packagesSection,
    hallPlanSection,
    bookingSection,
    participantsSection
  ].filter(Boolean);
  var revealTimer;
  var revealFrame;
  var revealFrameAfter;
  var responsiveMode = false;
  var initialAnchor = window.location.hash.replace(/^#/, '');

  var isAnimatedSection = function (section) {
    return animatedSections.indexOf(section) !== -1;
  };

  var cancelScheduledReveal = function () {
    window.clearTimeout(revealTimer);
    window.cancelAnimationFrame(revealFrame);
    window.cancelAnimationFrame(revealFrameAfter);
    revealTimer = null;
    revealFrame = null;
    revealFrameAfter = null;
  };

  var revealSection = function (section, afterPaint) {
    if (!isAnimatedSection(section)) return;

    if (!afterPaint) {
      section.classList.add('is-revealed');
      return;
    }

    revealFrame = window.requestAnimationFrame(function () {
      revealFrameAfter = window.requestAnimationFrame(function () {
        section.classList.add('is-revealed');
        revealFrame = null;
        revealFrameAfter = null;
      });
    });
  };

  var revealAllSections = function () {
    animatedSections.forEach(function (section) {
      section.classList.add('is-revealed');
    });
  };

  var getPreviousPanel = function (section) {
    var previousSection = section && section.previousElementSibling;

    while (
      previousSection &&
      !previousSection.classList.contains('front-page__panel')
    ) {
      previousSection = previousSection.previousElementSibling;
    }

    return previousSection;
  };

  var keepFooterContextVisible = function () {
    var contextSection = getPreviousPanel(footerSection);

    if (contextSection) {
      contextSection.classList.add('is-revealed');
    }

    return contextSection;
  };

  var isResponsiveViewport = function () {
    return (
      document.body.classList.contains('fp-responsive') ||
      window.innerWidth < 768 ||
      window.innerHeight < 650
    );
  };

  var getSectionByAnchor = function (anchor) {
    return sections.find(function (section) {
      return section.getAttribute('data-anchor') === anchor;
    });
  };

  var scrollToResponsiveAnchor = function (anchor, behavior) {
    var section = getSectionByAnchor(anchor);

    if (!section) return false;

    section.scrollIntoView({
      behavior: behavior || 'auto',
      block: 'start'
    });

    return true;
  };

  var syncDocumentOffset = function () {
    var adminBar = document.getElementById('wpadminbar');
    var adminBarHeight = adminBar ? adminBar.offsetHeight : 0;

    document.documentElement.classList.toggle(
      'meinplan-fullpage-active',
      !responsiveMode
    );
    document.documentElement.style.setProperty(
      '--meinplan-admin-bar-height',
      adminBarHeight + 'px'
    );
  };

  var enhanceNavigation = function () {
    var navigation = document.getElementById('fp-nav');

    if (!navigation) return;

    navigation.setAttribute('role', 'navigation');
    navigation.setAttribute('aria-label', 'Seitennavigation');

    Array.prototype.forEach.call(
      navigation.querySelectorAll('a'),
      function (link, index) {
        link.setAttribute(
          'aria-label',
          'Zum Abschnitt ' + navigationTooltips[index]
        );
      }
    );
  };

  if (!page) return;

  if (!config.licenseKey) {
    console.warn(
      'fullPage.js was not initialized because MEINPLAN_FULLPAGE_LICENSE_KEY is missing.'
    );
    return;
  }

  new fullpage('#fullpage', {
    licenseKey: config.licenseKey,
    sectionSelector: '.front-page__panel',
    scrollingSpeed: 800,
    easingcss3: 'cubic-bezier(0.77, 0, 0.175, 1)',
    autoScrolling: true,
    fitToSection: true,
    fitToSectionDelay: 700,
    scrollOverflow: true,
    bigSectionsDestination: 'top',
    keyboardScrolling: true,
    touchSensitivity: 5,
    verticalCentered: true,
    anchors: anchors,
    navigation: true,
    navigationPosition: 'right',
    navigationTooltips: navigationTooltips,
    showActiveTooltip: false,
    animateAnchor: false,
    recordHistory: false,
    lockAnchors: false,
    responsiveWidth: 768,
    responsiveHeight: 650,
    afterRender: function () {
      var activeSection = page.querySelector('.front-page__panel.active') || introSection;

      cancelScheduledReveal();
      animatedSections.forEach(function (section) {
        section.classList.remove('is-revealed');
      });
      enhanceNavigation();

      responsiveMode = isResponsiveViewport();
      syncDocumentOffset();

      if (responsiveMode) {
        revealAllSections();

        if (initialAnchor && initialAnchor !== 'start') {
          window.requestAnimationFrame(function () {
            scrollToResponsiveAnchor(initialAnchor, 'auto');
          });
        }

        return;
      }

      if (activeSection === footerSection) {
        keepFooterContextVisible();
        return;
      }

      revealSection(activeSection, Boolean(!initialAnchor || initialAnchor === 'start'));
    },
    onLeave: function (origin, destination) {
      cancelScheduledReveal();

      if (responsiveMode) {
        revealAllSections();
        return;
      }

      if (destination.item === footerSection) {
        keepFooterContextVisible();
        return;
      }

      origin.item.classList.remove('is-revealed');

      if (isAnimatedSection(destination.item)) {
        destination.item.classList.remove('is-revealed');
      }

      revealTimer = window.setTimeout(function () {
        revealTimer = null;
        revealSection(destination.item, false);
      }, 100);
    },
    afterLoad: function (origin, destination) {
      cancelScheduledReveal();

      if (responsiveMode) {
        revealAllSections();
        return;
      }

      if (destination.item === footerSection) {
        var contextSection = keepFooterContextVisible();

        animatedSections.forEach(function (section) {
          if (section !== contextSection) {
            section.classList.remove('is-revealed');
          }
        });
        return;
      }

      animatedSections.forEach(function (section) {
        if (section !== destination.item) {
          section.classList.remove('is-revealed');
        }
      });

      if (isAnimatedSection(destination.item)) {
        revealSection(destination.item, false);
      }
    },
    afterResponsive: function (isResponsive) {
      responsiveMode = isResponsive;
      cancelScheduledReveal();
      syncDocumentOffset();

      if (isResponsive) {
        revealAllSections();
        return;
      }

      animatedSections.forEach(function (section) {
        section.classList.remove('is-revealed');
      });
      var activeSection = page.querySelector('.front-page__panel.active');

      if (activeSection === footerSection) {
        keepFooterContextVisible();
        return;
      }

      revealSection(activeSection, true);
    }
  });

  nextButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      if (window.fullpage_api) {
        window.fullpage_api.moveSectionDown();
      }
    });
  });

  page.addEventListener('click', function (event) {
    var link = event.target.closest('a[href^="#"]');

    if (!responsiveMode || !link) return;

    var anchor = link.getAttribute('href').replace(/^#/, '');

    if (!getSectionByAnchor(anchor)) return;

    event.preventDefault();
    window.history.pushState(null, '', '#' + anchor);
    scrollToResponsiveAnchor(anchor, 'smooth');
  });
})();
